import * as React from "react";
import {DeliveryState, isAnyState} from "./types";
import {getDeliveryStateName} from "./utils";
import {Badge} from "@variocube/cube-ui";

interface DeliveryStateDisplayProps {
    deliveryState: DeliveryState;
}

export function DeliveryStateDisplay({deliveryState}: DeliveryStateDisplayProps) {

    return (
        <Badge success={isAnyState(deliveryState, [DeliveryState.PickedUp, DeliveryState.ManualHandover, DeliveryState.Shipped])}
               warning={isAnyState(deliveryState, [DeliveryState.Stored, DeliveryState.Returned])}
               error={isAnyState(deliveryState, [DeliveryState.Draft, DeliveryState.Cancelled])}>
            {getDeliveryStateName(deliveryState)}
        </Badge>
    );
}
